import * as React from 'react'
import styled from 'styled-components'

import { lightweight, standalone, SymbolProps } from '../../spritesheetUtils'
import { Icon } from '../Icon'
import { SpecificIconProps } from '../types'

const IMAGE_PATH = (
  <g>
    <path d="M11.827 6.18176C12.6108 6.18176 13.2463 5.54632 13.2463 4.76248C13.2463 3.97863 12.6108 3.3432 11.827 3.3432C11.0431 3.3432 10.4077 3.97863 10.4077 4.76248C10.4077 5.54632 11.0431 6.18176 11.827 6.18176Z" />
    <path d="M14.382 0.504761H1.70313C0.756948 0.504761 0 1.26171 0 2.20789V14.7922C0 15.7383 0.756948 16.4953 1.70313 16.4953H14.2874C15.2336 16.4953 15.9905 15.7383 15.9905 14.7922V2.20789C16.0852 1.26171 15.3282 0.504761 14.382 0.504761ZM13.6061 9.32321L11.5435 7.97963C11.165 7.69577 10.6919 7.69577 10.2188 7.97963L7.94796 9.20967C7.75872 9.30429 7.56948 9.20967 7.47487 9.11505L5.1094 6.46573C4.63631 5.89802 3.87936 5.89802 3.31165 6.46573L2.17623 7.60115C1.70313 8.06478 1.55174 8.19725 1.41928 8.33918C1.40035 7.97016 1.41928 7.85662 1.41928 7.3173V2.87022C1.41928 2.30251 1.89237 1.92404 2.36546 1.92404H13.6251C14.1928 1.92404 14.5713 2.39713 14.5713 2.87022V9.20967C14.5713 9.55029 14.5807 9.63545 14.5713 9.90038C14.2117 9.71115 13.8238 9.4746 13.6061 9.32321Z" />
  </g>
)

const ID = 'image-stroke-glyph-icon'

export function ImageSymbol({ id = ID, ...props }: SymbolProps): React.ReactElement<SymbolProps> {
  return (
    <symbol {...props} id={id} viewBox="0 0 16 17">
      {IMAGE_PATH}
    </symbol>
  )
}

const ImageStandaloneContent = standalone(ImageSymbol, ID)

export const Image = styled(function ImageComponent(props: SpecificIconProps) {
  return (
    <Icon {...props} name="image">
      <ImageStandaloneContent />
    </Icon>
  )
})``

export const ImageLightweight = styled(function ImageComponent(props: SpecificIconProps) {
  return (
    <Icon {...props} name="image-light-weight">
      {lightweight(ID)}
    </Icon>
  )
})``
